import { IKimAddress } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { SelectionItem } from 'src/app/shared/models/selectionItem';
import { AuthService } from 'src/app/shared/services/auth.service';

/**
 * Loads the logged-in user's own KIM addresses as selection items
 * (label includes the organization's IK number when known).
 */
@Injectable({ providedIn: 'root' })
export class KimSenderAddressService {
  constructor(private _authService: AuthService) {}

  public async getSenderSelectionItems(): Promise<SelectionItem[]> {
    const account = await this._authService.getAccount();
    const userKimAddresses = account?.kimAddresses ?? [];
    if (!userKimAddresses.length) {
      return [];
    }

    const organization = await this._authService.getCurrentUserOrganization();
    const organizationKimAddresses: IKimAddress[] = organization?.alberta?.kimAddresses ?? [];
    return userKimAddresses.map(kimAddress => {
      const organizationAddress = organizationKimAddresses.find(entry => entry.kimAddress === kimAddress);
      const label = organizationAddress ? `${kimAddress} (IK ${organizationAddress.ikNumber})` : kimAddress;
      return new SelectionItem(kimAddress, label);
    });
  }
}
